<template>
  <footer class="app-footer">
    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <v-container>
        <v-row align="center">
          <v-col cols="12" md="6">
            <p class="copyright">
              © {{ currentYear }} {{ $t('footer.copyright') }}
            </p>
          </v-col>
          
          <v-col cols="12" md="6" class="text-center text-md-end">
            <div class="footer-bottom-links">
              <router-link
                v-for="link in legalLinks"
                :key="link.key"
                :to="link.to"
                class="legal-link"
              >
                {{ $t(`footer.${link.key}`) }}
              </router-link>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

// Computed
const currentYear = computed(() => new Date().getFullYear())

const legalLinks = computed(() => [
  { key: 'privacy', to: '/privacy' },
  { key: 'terms', to: '/terms' },
  { key: 'cookies', to: '/cookies' }
])
</script>

<style lang="scss" scoped>
.app-footer {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: white;
  margin-top: auto;
}

.footer-bottom {
  background: rgba(0, 0, 0, 0.3);
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  .copyright {
    color: #ccc;
    margin: 0;
    font-size: 0.875rem;
  }

  .footer-bottom-links {
    display: flex;
    gap: 24px;
    justify-content: center;
    flex-wrap: wrap;

    @media (min-width: 960px) {
      justify-content: flex-end;
    }

    .legal-link {
      color: #ccc;
      text-decoration: none;
      font-size: 0.875rem;
      transition: color 0.3s ease;

      &:hover {
        color: #FFC107;
      }
    }
  }
}

// Mobile specific
@media (max-width: 768px) {
  .app-footer {
    background: #1a1a1a !important;
  }
  
  .footer-bottom {
    padding: 16px 0 !important;
    text-align: center !important;
  }
  
  .copyright {
    text-align: center !important;
    font-size: 0.85rem !important;
  }
  
  .footer-bottom-links {
    justify-content: center !important;
    margin-top: 12px !important;
  }
}

// Dark theme support
.v-theme--dark {
  .app-footer {
    background: linear-gradient(135deg, #121212 0%, #1e1e1e 100%);
  }
}
</style>